<template>
  <div class="component" >
    <h2>{{ scopedStrings.title }}</h2>
    <table class="performance_list">
      <tr class="performance" v-for="(value, index) in performanceData" :key="value.id">
        <td class="label">{{ scopedStrings.names[index] }}</td>
        <td class="value">{{ value }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      scopedStrings: {
        type: Object,
        required: true
      },
      initialValue: {
        required: true
      }
    },
    data () {
      return {
        performanceData: this.initialValue
      }
    },
    methods: {
      update (newValue) {
        // Trick used to trigger the component's render hook despite Vue change detection caveats on arrays.
        this.performanceData = newValue.slice();
      }
    }
  }
</script>

<style scoped>
  .component table {
    border-collapse: collapse;
  }
</style>
